function Services() {
    return (
        <section id="services" className="section">
            <div className="container">
                <div className="section-head reveal">
                <h2>Especialidades</h2>
                <p>Serviços contábeis completos — da escrituração à análise e consultoria para crescimento sustentável.</p>
                </div>

                <div className="cards-grid">
                <article className="card reveal">
                    <div className="card-icon" aria-hidden="true">🧾</div>
                    <h3>Contabilidade</h3>
                    <p>Gestão completa com demonstrações financeiras e análises para apoiar decisões estratégicas.</p>
                </article>

                <article className="card reveal">
                    <div className="card-icon" aria-hidden="true">📑</div>
                    <h3>Fiscal</h3>
                    <p>Obrigações fiscais em dia, conformidade com a legislação e acompanhamento de mudanças.</p>
                </article>

                <article className="card reveal">
                    <div className="card-icon" aria-hidden="true">👥</div>
                    <h3>Pessoal</h3>
                    <p>Rotinas trabalhistas e previdenciárias, apoio técnico e segurança na gestão de colaboradores.</p>
                </article>

                <article className="card reveal">
                    <div className="card-icon" aria-hidden="true">💼</div>
                    <h3>Consultoria Empresarial</h3>
                    <p>Gestão financeira, planejamento estratégico e melhoria de processos para crescer com consistência.</p>
                </article>

                <article className="card reveal">
                    <div className="card-icon" aria-hidden="true">📊</div>
                    <h3>Consultoria Tributária</h3>
                    <p>Planejamento tributário para otimizar custos, revisar tributos e garantir conformidade legal.</p>
                </article>

                <aside className="card card-accent reveal">
                    <h3>Quer uma análise inicial?</h3>
                    <p>Envie sua demanda e receba orientação para o melhor caminho contábil e tributário.</p>
                    <a className="btn btn-primary" href="https://wa.me/5519995277000" target="_blank">Solicitar contato</a>
                </aside>
                </div>
            </div>
        </section>
    );
}

export default Services;